import { createFileRoute } from '@tanstack/react-router'
import MedicalAppointmentPage from '@/features/medical/medical-appointment'

export const Route = createFileRoute('/_authenticated/medical/$appointmentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { appointmentId } = Route.useParams()

  return <MedicalAppointmentPage appointmentId={appointmentId} />
}
